"use client";

import { Button } from "@mantine/core";
import { useTranslations } from "next-intl";

type UnsubscribeContentProps = {
  handleSubscription: (acceptOffer: boolean) => void;
  setCurrentView: (view: "subscriptionConfirmation") => void;
  isLoading: boolean;
};

export function UnsubscribeContent({
  handleSubscription,
  setCurrentView,
  isLoading,
}: UnsubscribeContentProps) {
  const t = useTranslations("subscription");

  const perks: string[] = t.raw("downsale.perks");

  return (
    <div className="grid grid-cols-1 gap-y-6 lg:w-[447px]">
      <h2 className="text-xl font-semibold">{t("downsale.title")}</h2>
      <div className="space-y-3">
        <p className="text-base font-medium leading-6">
          {t("downsale.description")}
        </p>
        <p className="text-sm font-semibold">{t("downsale.includes")}</p>
        <ul className="ml-5 list-disc space-y-1 text-sm text-text-secondary">
          {perks.map((perk) => (
            <li key={perk}>{perk}</li>
          ))}
        </ul>
      </div>
      <div className="flex w-full flex-col-reverse items-center gap-4 pb-6 sm:flex-row sm:justify-between">
        <Button
          className="flex-1"
          variant="filled"
          color="dark"
          radius="xl"
          size="md"
          onClick={() => setCurrentView("subscriptionConfirmation")}
        >
          {t("downsale.decline")}
        </Button>
        <Button
          className="flex-1"
          variant="filled"
          radius="xl"
          size="md"
          onClick={() => handleSubscription(true)}
          disabled={isLoading}
          loading={isLoading}
        >
          {t("downsale.accept")}
        </Button>
      </div>
    </div>
  );
}
